/**
 * //////////////////////////////////////////////////
 * REDUCKSメインファイル
 * --------------------------
 *
 * セレクタ、オペレーション、サガ、リデューサを束ねるメインファイル。
 * Reducksの他のコンポーネント（serviceContracts）と結合するために、主にducks/index.jsファイルにエクスポートされます。
 * ///////////////////////////////////////////////////
 */

import * as watchersSagas from './watchersSagas';

export const serviceContractContentSagas = Object.values(watchersSagas);
export {default as serviceContractContentSelectors} from "./selectors";
export {default as serviceContractContentOperations} from "./operations";
export {default as serviceContractContentTypes} from "./types";
export {default as serviceContractContentForms} from "./forms"

export {serviceContractContentState, default as serviceContractContentReducer} from './reducers';
